import { Layout } from "antd";
import React, { FC } from "react";
import Header from "./Header";

import styles from "./styles.less";

const AppLayout: FC = ({ children }) => (
  <Layout className={styles.background}>
    <Header />
    <Layout.Content className={styles.content}>
      <main className={styles.body}>{children}</main>
    </Layout.Content>
  </Layout>
);

export default AppLayout;
